import {
  Button,
  Typography
} from "@material-ui/core";
import {
  DescriptionOutlined
} from "@material-ui/icons";
import axios from "axios";
import Config from "config";
import { getHeaders } from "helpers/headers";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { State } from "state";
import srs from "../assets/img/manage_data/srs.svg";

import { toggleStarredProject } from "state/starredProjects";
import { getDisplayDate } from "utils/helpers";
import TimezoneTitleSpan from "./utils/TimezoneTitleSpan";


interface ProjectDetailsCardProps {
  project: any;
  chainPermission: any;
  id?: number;
  roleId?: number;
  // Injected by connect
  toggleStarredProject: (payload: any) => Promise<void>;
}

const cardStyle: React.CSSProperties = {
  flex: "1 1 250px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};

const projectdetailStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  borderRadius: "12px",
  padding: "16px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
  display: "flex",
  flexDirection: "column",
  gap: "7px",
  background: "linear-gradient(128.26deg, #FFFFFF 61.03%, #E3BD21 153.87%)",
  height: "100%",
  position: "relative",
};

const titleStyle: React.CSSProperties = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#333",
};

const chainLogoContainerStyle: React.CSSProperties = {
  position: "absolute",
  top: "14px",
  right: "14px",
  width: "44px",
  height: "44px",
  backgroundColor: "#fff",
  borderRadius: "8px",
  border: "1px solid #E5E7EB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px",
};

const chainLogoStyle: React.CSSProperties = {
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
};

const labelStyle: React.CSSProperties = {
  fontSize: "12px",
  color: "#374151",
  fontWeight: 500,
};

const valueStyle: React.CSSProperties = {
  fontSize: "12px",
  color: "#929497",
};

const projectSurveyButtonStyle: React.CSSProperties = {
  textTransform: "none",
  background: "linear-gradient(180.26deg, #FFFFFF 61.03%, #E3BD21 153.87%)",
  color: "#000",
  padding: "8px 16px",
  border: "1px solid #E0E0E0",
  borderRadius: "12px",
  fontSize: "12px",
  width: "100%",
  display: "flex",
  justifyContent: "left"
};

const projectSurveyButtonStyle2: React.CSSProperties = {
  textTransform: "none",
  background: "linear-gradient(180.26deg, #FFFFFF 61.03%, #E3BD21 153.87%)",
  color: "#000",
  padding: "11.5px 16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  border: "1px solid #E0E0E0",
  borderRadius: "12px",
  fontSize: "12px",
  width: "100%",
};

const buttonIconStyle: React.CSSProperties = {
  // marginRight: "8px",
  color: "rgb(229, 182, 17)",
};

type CombineProps = ProjectDetailsCardProps & RouteComponentProps;


const ProjectDetailsCard: React.FC<CombineProps> = ({
  project,
  chainPermission,
  history,
  id,
  roleId,
  toggleStarredProject,
}) => {
  const authUser = useSelector((state: State) => state.auth_user.content);
  const userRole = authUser?.role;
  const isInitiallyStarred = project?.isStarred === true;
  // Initial state from backend
  const [isStarred, setIsStarred] = useState<boolean>(isInitiallyStarred);
  const [loading, setLoading] = useState(false)

  const [chainLogoSrc, setChainLogoSrc] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    const fetchLogo = async () => {
      const chainId = project?.chain?.id;
      if (!chainId) return;
      try {
        const resp = await axios.get(`${Config.API_SERVICE_URL}/api/chains/me`, getHeaders());
        const chains: any[] = Array.isArray(resp.data) ? resp.data : [];
        const matched = chains.find((c: any) => Number(c.id) === Number(chainId));
        const chainParentId = matched?.chain_parent_id ?? matched?.chain_parent;
        if (!chainParentId) return;
        const logoUrl = `${Config.API_SERVICE_URL}/api/chain-parent-logo/${chainParentId}/image`;
        if (!cancelled) setChainLogoSrc(logoUrl);
      } catch { }
    };
    fetchLogo();
    return () => { cancelled = true; };
  }, [project?.chain?.id]);
  
const handleStarToggle = async () => {
  const starred = !isStarred;

  try {
    await toggleStarredProject({
      user_id: authUser?.id,
      project_id: project.id,
      project_name: project.project_name,
      project_type: project.project_type,
      announcement_count: 5,
      survey_count: 5,
      starred,          // true or false
    });

    setIsStarred(starred);
  } catch (error) {
    console.error("Failed to toggle starred project", error);
  }
};


  return (
    <div style={cardStyle}>
      <div style={projectdetailStyle}>
        {chainLogoSrc && (
          <div style={chainLogoContainerStyle}>
            <img src={chainLogoSrc} alt="" style={chainLogoStyle} onError={() => setChainLogoSrc(null)} />
          </div>
        )}
        {/* STAR BUTTON */}
        {/* <IconButton
          onClick={handleStarToggle}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            color: isStarred ? "#F5C518" : "#9CA3AF",
            cursor: "pointer",
          }}
        >
          {isStarred ? <Star /> : <StarBorder />}
        </IconButton> */}


        <Typography variant="h6" style={titleStyle}>
          Project Details
        </Typography>

        <Typography style={labelStyle}>Project Name</Typography>
        <Typography style={valueStyle}>{project?.name}</Typography>

        <Typography style={labelStyle}>Chain</Typography>
        <Typography style={valueStyle}>{project?.chain?.name}</Typography>

        <Typography style={labelStyle}>
          Estimated Completion Date
        </Typography>
        <Typography style={valueStyle}>
          <TimezoneTitleSpan
            dateValue={project?.est_complete_date}
            timezone={project?.timezone}
          >
            {getDisplayDate({date: project?.est_complete_date, timezone: project?.timezone})}
          </TimezoneTitleSpan>
        </Typography>

        <Typography style={labelStyle}>Number of Stores</Typography>
        <Typography style={valueStyle}>
          {project?.user_store_count}
        </Typography>
      </div>

      <div style={{ display: "flex", gap: "10px", justifyContent: "right" }}>
        {project?.survey_url && ( <Button
              // variant="contained"
              style={projectSurveyButtonStyle}
              startIcon={<DescriptionOutlined style={buttonIconStyle} />}
              onClick={() => {
                const url = project.survey_url.startsWith("http")
                  ? project.survey_url
                  : `https://${project.survey_url}`;
                window.open(url, "_blank");
              }}
            >
              Project Surveys
            </Button>
          )}

        <button
          onClick={() =>
            history.push(
              `/projects-new/${id}/${roleId}/store-reset-status/${id}`
            )
          }
          style={projectSurveyButtonStyle2}
        >
          <img src={srs} alt="Store Reset Status" width="16" height="16" />
          Store Reset Status
        </button>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleStarredProject,
};

export default connect(
  null,
  mapDispatchToProps
)(withRouter(ProjectDetailsCard));